/**
 * Lire la résiliation de son entreprise.
 *
 * N1, ouvert à tous les rôles : l'ouvrier doit savoir, lui aussi, que plus
 * rien ne s'écrit. La résiliation se pose et s'annule depuis la console staff,
 * jamais d'ici.
 */
import { ActionLevel } from "../../levels.js";
import { defineService } from "../../service.js";
import type { ExecutionContext } from "../../context.js";
import type { ServiceInput } from "../../service.js";
import type { TenantTermination } from "./types.js";

export interface TerminationRepository {
  /** La résiliation de l'entreprise de `ctx`, ou `null` s'il n'y en a pas. */
  mine(ctx: ExecutionContext): Promise<TenantTermination | null>;
}

export function createTerminationServices(repo: TerminationRepository) {
  const lireResiliation = defineService<ServiceInput, TenantTermination | null>({
    name: "lire_resiliation",
    level: ActionLevel.Read,
    handler: (ctx) => repo.mine(ctx),
  });

  return { lireResiliation };
}

export type TerminationServices = ReturnType<typeof createTerminationServices>;
